import { render } from "./TheBikeTypeCreationForm.vue?vue&type=template&id=efa3ffe4"
import script from "./TheBikeTypeCreationForm.vue?vue&type=script&lang=js"
export * from "./TheBikeTypeCreationForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__